module.exports = __webpack_public_path__ + "img/dec4_06.f08407c0.jpeg";